// Small localStorage-backed cache with a TTL, used to seed an instant first paint
// (e.g. a returning visitor's last-known value) ahead of a fresh network fetch.
export type TtlCacheEntry<T> = {
  data: T;
  cachedAt: number;
};

export function readTtlCache<T>(key: string, ttlMs: number): TtlCacheEntry<T> | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { data, cachedAt } = JSON.parse(raw);
    if (!cachedAt || Date.now() - cachedAt > ttlMs) return null;
    return { data: data as T, cachedAt };
  } catch {
    return null;
  }
}

export function writeTtlCache<T>(key: string, data: T): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify({ data, cachedAt: Date.now() }));
  } catch {
    // Ignore QuotaExceededError / SecurityError
  }
}
